import axios from 'axios';
import { retrieveStudyMetadata } from './retrieveStudyMetadata';

export const createDtxUID = (uuidStr) => {
    return `7.1.${window.BigInt('0x' + uuidStr.replace(/-/g, '')).toString()}`;
}

const getWadoImageInfo = async (testCaseId, dicomServerUrl) => {
    const studyInstanceUID = createDtxUID(testCaseId);
    const studiesData = await retrieveStudyMetadata({
        "name": "DCM4CHEE",
        // "wadoUriRoot": "https://server.dcmjs.org/dcm4chee-arc/aets/DCM4CHEE/wado",
        "qidoRoot": dicomServerUrl,
        "wadoRoot": dicomServerUrl,
        "qidoSupportsIncludeField": true,
        "imageRendering": "wadors",
        "thumbnailRendering": "wadors",
        "enableStudyLazyLoad": true,
        "supportsFuzzyMatching": true,
        "type": "dicomWeb",
        "active": true
    }, studyInstanceUID, {});

    // loadRemainingSeries
    const { seriesLoader } = studiesData;
    if (!seriesLoader) return studiesData;
    const loadNextSeries = async () => {
        if (!seriesLoader.hasNext()) return;
        const series = await seriesLoader.next();
        const seriesIndex = studiesData.series.findIndex(v => v.SeriesInstanceUID === series.SeriesInstanceUID);
        if(seriesIndex === -1) {
            studiesData.series.push(series);
        } else {
            studiesData.series[seriesIndex] = series;
        }
        return loadNextSeries();
    };

    const promises = Array(studiesData.series.length).fill(null).map(loadNextSeries);
    await Promise.all(promises);
    return studiesData;

};

export default getWadoImageInfo;
